import { env } from "../env";

// API Configuration
export const API_CONFIG = {
	baseURL:
		typeof window !== "undefined"
			? window.location.origin
			: env.VITE_API_BASE_URL,
	endpoints: {
		auth: "/api/auth",
		settings: "/api/settings",
		nocodb: "/api/nocodb",
		webhooks: "/api/webhooks",
	},
} as const;

// Helper function to build full API URLs
export const buildApiUrl = (endpoint: string): string => {
	return `${API_CONFIG.baseURL}${endpoint}`;
};

// Specific API URL builders
export const API_URLS = {
	// Auth endpoints
	auth: (path = "") => buildApiUrl(`${API_CONFIG.endpoints.auth}${path}`),

	// Settings endpoints
	settings: {
		get: (userId: string) =>
			buildApiUrl(`${API_CONFIG.endpoints.settings}/${userId}`),
		create: () => buildApiUrl(API_CONFIG.endpoints.settings),
		update: (userId: string) =>
			buildApiUrl(`${API_CONFIG.endpoints.settings}/${userId}`),
		delete: (userId: string) =>
			buildApiUrl(`${API_CONFIG.endpoints.settings}/${userId}`),
	},

	articles: {
		delete: (articleId: string | number) =>
			buildApiUrl(`/api/articles/${encodeURIComponent(String(articleId))}/delete`),
	},

	// NocoDB proxy endpoints (secure server-side)
	nocodb: {
		base: () => buildApiUrl(API_CONFIG.endpoints.nocodb),
		tables: (tableId: string) =>
			buildApiUrl(`${API_CONFIG.endpoints.nocodb}/tables/${tableId}/records`),
		table: (tableId: string, recordId?: string) =>
			buildApiUrl(
				`${API_CONFIG.endpoints.nocodb}/tables/${tableId}/records${recordId ? `/${recordId}` : ""}`,
			),
	},

	// n8n webhook proxy endpoints (secure server-side)
	webhooks: {
		n8n: (workflow: string) =>
			buildApiUrl(`${API_CONFIG.endpoints.webhooks}/n8n/${workflow}`),
	},
} as const;
